import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label"]
  static values = {
    checked: { type: String, default: "Yes" },
    unchecked: { type: String, default: "No" }
  }

  connect() {
    this.update()
  }

  update() {
    this.labelTarget.textContent = this.checkboxTarget.checked
      ? this.checkedValue
      : this.uncheckedValue
  }
}
